module.exports = __webpack_public_path__ + "static/media/globe.1b085a38.png";